export const InfoLineKeys = {
  DURATION_IN_MONTHS: 'DURATION_IN_MONTHS',
  CREDIT_AMOUNT: 'CREDIT_AMOUNT',
  INTEREST: 'INTEREST',
  MONTHLY_ADMIN_FEE: 'MONTHLY_ADMIN_FEE',
  NORMAL_MONTHLY_REPAYMENT_AMOUNT: 'NORMAL_MONTHLY_REPAYMENT_AMOUNT',
  EFFECTIVE_INTEREST: 'EFFECTIVE_INTEREST',
  ARRANGEMENT_FEE: 'ARRANGEMENT_FEE',
  CREDIT_COST: 'CREDIT_COST',
  TOTAL_LOAN_COST: 'TOTAL_LOAN_COST',
}

export const InfoLineType = {
  CURRENCY: 'CURRENCY',
  PERCENTAGE: 'PERCENTAGE',
  MONTH: 'MONTH',
}

export const InfoLineProperties = {
  [InfoLineKeys.DURATION_IN_MONTHS]: {
    label: 'priceInfo.infoLine.durationInMonths',
    type: InfoLineType.MONTH,
  },
  [InfoLineKeys.CREDIT_AMOUNT]: {
    label: 'priceInfo.infoLine.creditAmount',
    type: InfoLineType.CURRENCY,
  },
  [InfoLineKeys.INTEREST]: {
    label: 'priceInfo.infoLine.interest',
    type: InfoLineType.PERCENTAGE,
  },
  [InfoLineKeys.MONTHLY_ADMIN_FEE]: {
    label: 'priceInfo.infoLine.monthlyAdminFee',
    type: InfoLineType.CURRENCY,
  },
  [InfoLineKeys.NORMAL_MONTHLY_REPAYMENT_AMOUNT]: {
    label: 'priceInfo.infoLine.normalMonthlyRepaymentAmount',
    type: InfoLineType.CURRENCY,
    reservations: 1,
  },
  [InfoLineKeys.EFFECTIVE_INTEREST]: {
    label: 'priceInfo.infoLine.effectiveInterest',
    type: InfoLineType.PERCENTAGE,
  },
  [InfoLineKeys.ARRANGEMENT_FEE]: {
    label: 'priceInfo.infoLine.arrangementFee',
    type: InfoLineType.CURRENCY,
    reservations: 2,
  },
  [InfoLineKeys.CREDIT_COST]: {
    label: 'priceInfo.infoLine.creditCost',
    type: InfoLineType.CURRENCY,
  },
  [InfoLineKeys.TOTAL_LOAN_COST]: {
    label: 'priceInfo.infoLine.totalLoanCost',
    type: InfoLineType.CURRENCY,
  },
}
